export default {
    inside: require('./inside.png'),
    outside: require('./outside.png'),
    playersheetInside: require('./playersheet-inside.png'),
    playersheetOutside: require('./playersheet-outside.png'),
    moshuiping: require('./moshuiping.png'),
    button1: require('./button1.png'),
    button2: require('./button2.png'),
    button3: require('./button3.png'),
    button4: require('./button4.png'),
    button5: require('./button5.png'),
    piano1: require('./piano1.mp3'),
    piano2: require('./piano2.mp3'),
    piano3: require('./piano3.mp3'),
    piano4: require('./piano4.mp3'),
    piano5: require('./piano5.mp3'),
    pianoPass: require('./piano_pass.jpg'),
};



// WEBPACK FOOTER //
// ./src/game/scene1/asset/index.ts